<section class="allUsers w-full max-w-6xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <header class="flex flex-col md:flex-row md:items-end md:justify-between gap-3">
    <div class="flex flex-col gap-1">
      <p class="text-base text-ink-500">מתפללים</p>
      <h1 class="text-3xl font-bold text-primary-700">כל המשתמשים</h1>
    </div>

    <a routerLink="/prayers/add" class="btn-2026--primary w-full md:w-auto md:min-w-[200px]">
      <span class="material-symbols-outlined" aria-hidden="true">person_add</span>
      הוסף מתפלל
    </a>
  </header>

  <ng-container *ngIf="users$ | async as users; else loadingState">
    <ng-container *ngIf="users.length > 0; else empty">

      <!-- ── Mobile cards (< md) ───────────────────────────────────── -->
      <div class="md:hidden space-y-2">
        <div *ngFor="let user of users"
             class="card-2026 !p-3 block hover:bg-primary-50/40 transition-colors"
             [routerLink]="['/prayers/overall-table', user._id]">
          <div class="flex justify-between items-start gap-3">
            <div class="min-w-0 flex-1">
              <div class="font-bold text-ink-800 text-base truncate">
                {{ user.firstName }} {{ user.lastName }}
              </div>
              <div class="text-xs text-ink-500 mt-1">
                <ng-container *ngIf="user.lastSeen; else neverSeenMobile">
                  התחבר: {{ user.lastSeen | date : 'd בMMM y' : '' : 'he-IL' }}
                </ng-container>
                <ng-template #neverSeenMobile>לא התחבר</ng-template>
              </div>
              <div class="text-xs text-ink-500 mt-0.5">
                הצטרף: {{ user.createdAt | date : 'd בMMM y' : '' : 'he-IL' }}
              </div>
            </div>

            <div class="flex flex-col items-end gap-2 shrink-0">
              <div class="money font-bold text-lg"
                   [class.money--credit]="user.balance > 0"
                   [class.money--debt]="user.balance < 0"
                   [class.money--zero]="user.balance === 0">
                {{ user.balance | currency : 'ILS' : 'symbol' : '1.0-0' }}
              </div>
              <button
                type="button"
                class="btn-2026--danger !min-h-[36px] !py-1 !px-2 !text-sm"
                (click)="$event.stopPropagation(); onSubmit(user._id)"
                [attr.aria-label]="'מחק את ' + user.firstName + ' ' + user.lastName"
              >
                <i class="material-symbols-outlined !text-lg" aria-hidden="true">delete</i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- ── Tablet+ table (≥ md) ─────────────────────────────────── -->
      <div class="hidden md:block overflow-x-auto">
        <table class="table-2026 w-full">
          <thead>
            <tr>
              <th>שם מלא</th>
              <th class="text-end">יתרה</th>
              <th>התחבר לאחרונה</th>
              <th>תאריך הרשמה</th>
              <th class="text-center">פעולות</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let user of users"
              class="cursor-pointer"
              [routerLink]="['/prayers/overall-table', user._id]"
            >
              <td class="font-semibold">{{ user.firstName }} {{ user.lastName }}</td>
              <td class="text-end money font-semibold"
                  [class.money--credit]="user.balance > 0"
                  [class.money--debt]="user.balance < 0"
                  [class.money--zero]="user.balance === 0">
                {{ user.balance | currency : 'ILS' : 'symbol' : '1.0-0' }}
              </td>
              <td>
                <ng-container *ngIf="user.lastSeen; else neverSeen">
                  {{ user.lastSeen | date : 'd בMMM y, HH:mm' : '' : 'he-IL' }}
                </ng-container>
                <ng-template #neverSeen><span class="text-ink-400">לא התחבר</span></ng-template>
              </td>
              <td>{{ user.createdAt | date : 'd בMMM y' : '' : 'he-IL' }}</td>
              <td class="text-center" (click)="$event.stopPropagation()">
                <button
                  type="button"
                  class="btn-2026--danger !min-h-[40px] !py-1 !px-3 !text-base"
                  (click)="onSubmit(user._id)"
                  [attr.aria-label]="'מחק את ' + user.firstName + ' ' + user.lastName"
                >
                  <i class="material-symbols-outlined" aria-hidden="true">delete</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>

    <ng-template #empty>
      <div class="card-2026 text-center py-12">
        <i class="material-symbols-outlined text-5xl text-ink-300 mb-2" aria-hidden="true">group</i>
        <h2 class="text-xl font-semibold text-ink-700">אין משתמשים במערכת</h2>
        <p class="text-base text-ink-500 mt-1">הוסף משתמש חדש כדי להתחיל</p>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #loadingState>
    <div class="card-2026 space-y-3">
      <div class="skeleton-2026 h-12 w-full"></div>
      <div class="skeleton-2026 h-12 w-full"></div>
      <div class="skeleton-2026 h-12 w-full"></div>
    </div>
  </ng-template>
</section>
